export default function MarketOpportunity() {
  return (
    <section className="py-20 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-8 md:px-16">
        {/* Heading */}
        <div className="text-center mb-16">
          <div className="w-16 h-1 bg-[#D4AF37] mx-auto mb-8"></div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-[#1A2B4A] leading-tight font-serif">
            日本人の10人に1人が「車のローン」を組めない。<br />
            900万人が取り残された、<br />
            知られざる巨大市場の正体とは
          </h2>
        </div>

        {/* Vertical Layout - Infographic First, Then Text */}
        <div className="max-w-4xl mx-auto space-y-12">
          {/* Infographic */}
          <div className="bg-gradient-to-br from-[#F8F9FA] to-[#E8EAF0] p-12 rounded-3xl shadow-lg">
            <div className="space-y-8">
              {/* Total Market */}
              <div className="text-center">
                <div className="text-6xl font-black text-[#1A2B4A] mb-2 font-serif">1,000万人</div>
                <div className="text-lg text-gray-600 font-serif">低与信者市場</div>
              </div>

              {/* Arrow Down */}
              <div className="flex justify-center">
                <i className="ri-arrow-down-line text-4xl text-[#D4AF37]"></i>
              </div>

              {/* Approval Rate */}
              <div className="bg-white p-6 rounded-2xl shadow-md">
                <div className="flex items-center justify-between mb-4">
                  <span className="text-lg font-bold text-gray-700 font-serif">審査通過率</span>
                  <span className="text-3xl font-black text-[#D4AF37] font-serif">10%</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-4">
                  <div className="bg-gradient-to-r from-[#D4AF37] to-[#F4C542] h-4 rounded-full" style={{ width: '10%' }}></div>
                </div>
              </div>

              {/* Arrow Down */}
              <div className="flex justify-center">
                <i className="ri-arrow-down-line text-4xl text-[#D4AF37]"></i>
              </div>

              {/* Untapped Market */}
              <div className="text-center bg-[#1A2B4A] p-8 rounded-2xl">
                <div className="text-5xl font-black text-[#D4AF37] mb-2 font-serif">900万人</div>
                <div className="text-lg text-white font-serif">未開拓市場</div>
              </div>
            </div>
          </div>

          {/* Text Content - Increased Font Size */}
          <div className="space-y-6">
            <p className="text-xl text-gray-700 leading-relaxed font-serif">
              日本国内には、日々の生活や仕事に車が不可欠でありながら、過去の債務整理や非正規雇用といった理由で通常の自動車ローンが組めない「低与信者」が約<span className="text-[#D4AF37] font-bold text-2xl">1,000万人</span>存在します。
            </p>
            <p className="text-xl text-gray-700 leading-relaxed font-serif">
              そのうち、実際にローン審査を通過できるのはわずか<span className="text-[#D4AF37] font-bold text-2xl">10%</span>程度。
            </p>
            <p className="text-xl text-gray-700 leading-relaxed font-serif">
              つまり、約<span className="text-[#D4AF37] font-bold text-2xl">900万人</span>が「移動の足」を奪われ、社会から取り残されているのが現状です。
            </p>
            <p className="text-xl text-gray-700 leading-relaxed font-serif">
              この巨大な需要があるにもかかわらず、リスクを恐れて誰も手を付けられない——。ここに、我々が独占状態で利益を生み出し続けられる「市場の歪み」の正体があります。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
